var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("RoleManagement.common.RoleName"),
                          prop: "name",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: 20,
                            placeholder: _vm.$t(
                              "RoleManagement.common.RoleName"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "name", $$v)
                            },
                            expression: "queryParams.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("RoleManagement.common.Status"),
                          prop: "enabled",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_TRUE,
                            placeholder: _vm.$t("RoleManagement.common.Status"),
                          },
                          model: {
                            value: _vm.queryParams.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "enabled", $$v)
                            },
                            expression: "queryParams.enabled",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "AccountManagement.common.belongto"
                              ),
                              prop: "belongTo",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                clearable: false,
                                "option-list": _vm.STATUS_ENABLED_TRUES,
                                placeholder: _vm.$t(
                                  "AccountManagement.common.belongto"
                                ),
                              },
                              model: {
                                value: _vm.queryParams.belongTo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "belongTo", $$v)
                                },
                                expression: "queryParams.belongTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("RoleManagement.common.describe"),
                          prop: "description",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "RoleManagement.common.describe"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "description", $$v)
                            },
                            expression: "queryParams.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessUserRoleIndex_AddRole",
                            arg: "BusinessUserRoleIndex_AddRole",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addRole(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("RoleManagement.common.create")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "enabled"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.enabled
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row.enabled
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessUserRoleIndex_Edit",
                                            arg: "BusinessUserRoleIndex_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRole(2, props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        attrs: { size: "mini" },
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("table.operationText")
                                                )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            props.row.enabled
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessUserRoleIndex_Status",
                                                        arg: "BusinessUserRoleIndex_Status",
                                                      },
                                                    ],
                                                    attrs: {
                                                      command:
                                                        _vm.$t("disableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("disableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !props.row.enabled
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessUserRoleIndex_Status",
                                                        arg: "BusinessUserRoleIndex_Status",
                                                      },
                                                    ],
                                                    attrs: {
                                                      command:
                                                        _vm.$t("enableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("enableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:BusinessUserRoleAllotUser",
                                                    arg: "BusinessUserRoleAllotUser",
                                                  },
                                                ],
                                                attrs: {
                                                  command: _vm.$t(
                                                    "RoleManagement.common.users"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "RoleManagement.common.users"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:BusinessUserRoleAllotMenu",
                                                    arg: "BusinessUserRoleAllotMenu",
                                                  },
                                                ],
                                                attrs: {
                                                  command: _vm.$t(
                                                    "RoleManagement.common.menu"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "RoleManagement.common.menu"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:BusinessUserRoleAllot_Log",
                                                    arg: "BusinessUserRoleAllot_Log",
                                                  },
                                                ],
                                                attrs: {
                                                  command: _vm.$t(
                                                    "RoleManagement.common.Log"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "RoleManagement.common.Log"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.addDialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("RoleManagement.common.RoleName"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("RoleManagement.common.describe"),
                    prop: "describe",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.rolePermissionDialogVisible,
            width: "600px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.rolePermissionDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-custom-class-body-div" },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.rolePermissionList,
                  "show-checkbox": "",
                  "default-expand-all": "",
                  "node-key": "id",
                  "highlight-current": "",
                  props: _vm.defaultProps,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return [
                        _c(
                          "div",
                          [
                            _vm._v(" " + _vm._s(node.label) + " "),
                            data.permissionType == "button"
                              ? _c("el-tag", { attrs: { type: "warning" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("RoleManagement.common.button")
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            data.permissionType == "api"
                              ? _c("el-tag", [_vm._v("API")])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmRolePermission },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }